import React__default from 'react';

function LeftArrowBlackIcon() {
    return (React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M11.04 7.5L7.29 11.25V12.3L11.04 16.05L12.105 15L9.645 12.525H18V11.025H9.645L12.12 8.55L11.04 7.5Z", fill: "#2D2D2D" })));
}

export { LeftArrowBlackIcon as default };
//# sourceMappingURL=left-icon-black.icon.js.map
